function formatDuration(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m}min`;
  if (m === 0) return `${h}h`;
  return `${h}h${m}`;
}

interface FreeSlotsHeaderProps {
  readonly totalFreeMinutes: number;
}

export function FreeSlotsHeader({ totalFreeMinutes }: FreeSlotsHeaderProps) {
  return (
    <div className="p-4 bg-surface border border-border rounded-xl text-center">
      <div className="text-2xl font-black text-accent">
        {formatDuration(totalFreeMinutes)}
      </div>
      <div className="text-xs text-ink-muted mt-0.5 uppercase tracking-wide">
        Temps libre total cette semaine
      </div>
    </div>
  );
}
